import Descredenciados from './Descredenciados.vue'

const DescredenciadosRouter = {
  path: '/descredenciados',
  component: Descredenciados
}

export default DescredenciadosRouter
